import useFaqState from '../../hooks/useFaqState'
import { useMemo } from 'react'
import { IFaqCategory } from '../../faq.types'
import Select from '../../../../../shared/Inputs/Select'

interface IProps {
  value: IFaqCategory['id']
  name: string
  onChange: (val: IFaqCategory['id'], name: string) => void
}

const FaqGroupSelect = (props: IProps) => {
  const { categories } = useFaqState()

  const options = useMemo(() => {
    return [...categories.map((c) => ({ value: c.id, label: c.title })), { value: null, label: 'Нет' }]
  }, [categories])

  return (
    <Select
      onChange={props.onChange}
      selectedOption={options.find((o) => o.value === props.value)}
      name={props.name}
      options={options}
    />
  )
}

export default FaqGroupSelect
